import { OutreachLevel, type OutreachSignUpCheck } from "./models";

/** Minutes between two calls: the Calls level's pace, and the faster one from the Overtime level. */
export const CALL_GAP_MINUTES = { steady: 10, fast: 5 } as const;
/** The level that turns each allowed channel on. */
export const LEVEL_OF_ALLOWED = { calls: OutreachLevel.Calls, overtime: OutreachLevel.Overtime, agency: OutreachLevel.Agency } as const;

/** We recommend approving a sign-up that adds no overtime and doesn't clash with another shift. */
export const isRecommendedSignUp = (check: OutreachSignUpCheck): boolean => check.overtimeHours === 0 && !check.hasConflict;
